import type { Variants } from 'framer-motion';

const ease = [0.25, 0.46, 0.45, 0.94] as const;

// Página inteira ao entrar (PageShell)
export const pageVariants: Variants = {
  initial: { opacity: 0, y: 14 },
  animate: { opacity: 1, y: 0,  transition: { duration: 0.35, ease } },
};

// Container que aplica stagger nos filhos
export const staggerContainer: Variants = {
  initial: {},
  animate: { transition: { staggerChildren: 0.07, delayChildren: 0.05 } },
};

// Filho individual de stagger
export const staggerItem: Variants = {
  initial: { opacity: 0, y: 18 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.32, ease } },
};

// Dropdown popup (ChannelSwitcher, NotificationBell)
export const dropdownVariants: Variants = {
  initial: { opacity: 0, scale: 0.95, y: -6 },
  animate: { opacity: 1, scale: 1,    y: 0,  transition: { duration: 0.16, ease: 'easeOut' } },
  exit:    { opacity: 0, scale: 0.95, y: -6,  transition: { duration: 0.1  } },
};

// Fade simples (banners, alertas)
export const fadeIn: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3 } },
};
